<template>
  <ul v-if="listItems" :class="[wrapperClass, openClose]">
    <li v-for="(item, index) in listItems"
        :key="index"
        :class="spanItemClass"
        @click="$emit('clickAction', item)">
      <span>{{item}}</span>
    </li>
  </ul>
</template>

<script>
  export default {
    props: {
      customItemClasses: String,
      customWrapperClasses: String,
      listItems: Array,
      openClose: String,
      separator: String,
    },

    name: 'ClickableList',

    data() {
      return {
        spanItemClass: 'span-list-item',
        wrapperClass: 'span-list-wrapper',
      }
    },

    created() {
      this.spanItemClass = this.customItemClasses ? this.customItemClasses : 'clickable-list-item'
      this.wrapperClass = this.customWrapperClasses ? this.customWrapperClasses: 'clickable-list-wrapper'
    }
  }
</script>

<style lang="sass">
  //
  //  clickable list
  //
  .selected-data-type
    color: #128ff9
    cursor: pointer

    &:hover
      opacity: 0.5

    .group-name-section div,
    .group-name-section
      display: inline

    .group-name:after
      display: none
</style>